module.exports = "/build/web/svg/article-type-photos.ff8425fc9a88057e13334c56c345dd27.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/article-type-photos.svg
// module id = 144
// module chunks = 24